/**
 * <visualise-row> — the Roomvo / CharpstAR row under the product gallery
 * (sections/main-product.liquid). Both vendors decide per product, after load:
 * Roomvo flips its button from visibility:hidden to visible; CharpstAR shows its
 * container and, for a rug without a model, hides it again ~300ms later.
 *
 * The row keeps its reserved height from the first paint (Roomvo covers most rugs),
 * so a vendor button appearing never moves the page. This element turns the vendors'
 * inline styles into stable state classes the CSS lays out from:
 *   has-roomvo — Roomvo is showing
 *   has-3d     — CharpstAR has stayed visible for AR_STABLE_MS (no show-then-hide flash)
 *   is-empty   — neither showed within SETTLE_MS: the row folds away
 */
if (!customElements.get('visualise-row')) {
  const AR_STABLE_MS = 700;
  const SETTLE_MS = 3000;

  class VisualiseRow extends HTMLElement {
    connectedCallback() {
      this.roomvo = this.querySelector('.roomvo-stimr');
      this.ar = this.querySelector('charpstar-container');
      this.observer = new MutationObserver(() => this.update());
      [this.roomvo, this.ar].filter(Boolean).forEach((el) =>
        this.observer.observe(el, { attributes: true, attributeFilter: ['style'], childList: true })
      );
      this.settleTimer = setTimeout(() => {
        this.settled = true;
        this.update();
      }, SETTLE_MS);
      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      clearTimeout(this.settleTimer);
      clearTimeout(this.arTimer);
    }

    arVisible() {
      return Boolean(this.ar && this.ar.style.display !== 'none' && this.ar.querySelector('button'));
    }

    update() {
      const roomvo = Boolean(this.roomvo && this.roomvo.style.visibility !== 'hidden');
      this.classList.toggle('has-roomvo', roomvo);

      if (!this.arVisible()) {
        clearTimeout(this.arTimer);
        this.arTimer = null;
        this.classList.remove('has-3d');
      } else if (!this.classList.contains('has-3d') && !this.arTimer) {
        this.arTimer = setTimeout(() => {
          this.arTimer = null;
          this.classList.toggle('has-3d', this.arVisible());
          this.update();
        }, AR_STABLE_MS);
      }

      this.classList.toggle('is-empty', Boolean(this.settled) && !roomvo && !this.classList.contains('has-3d'));
    }
  }

  customElements.define('visualise-row', VisualiseRow);
}
